export var IE_USER_AGENT = /MSIE|Trident/;